import React from 'react';
export const SlateVeltComment = (props) => {
    const { attributes, children, element } = props;
    const annotationId = element === null || element === void 0 ? void 0 : element.annotationId;
    return (React.createElement("velt-comment-text", Object.assign({ "annotation-id": annotationId }, attributes), children));
};
